import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged,
  User,
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth';
import { auth } from '../firebase';

export interface AuthUser {
  uid: string;
  email: string | null;
}

class AuthService {
  // 註冊新用戶
  async signUp(email: string, password: string): Promise<AuthUser> {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      console.log('用戶註冊成功:', user.uid);
      return {
        uid: user.uid,
        email: user.email
      };
    } catch (error: any) {
      console.error('註冊失敗:', error.message);
      throw new Error(error.message);
    }
  }

  // 用戶登入
  async signIn(email: string, password: string): Promise<AuthUser> {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      console.log('用戶登入成功:', user.uid);
      return {
        uid: user.uid,
        email: user.email
      };
    } catch (error: any) {
      console.error('登入失敗:', error.message);
      throw new Error(error.message);
    }
  }

  // Google登入
  async signInWithGoogle(): Promise<AuthUser> {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      
      console.log('Google登入成功:', user.uid);
      return {
        uid: user.uid,
        email: user.email
      };
    } catch (error: any) {
      console.error('Google登入失敗:', error.message);
      throw new Error(error.message);
    }
  }

  // 用戶登出
  async signOut(): Promise<void> {
    try {
      await signOut(auth);
      console.log('用戶登出成功');
    } catch (error: any) {
      console.error('登出失敗:', error.message);
      throw new Error(error.message);
    }
  }

  // 監聽認證狀態變化
  onAuthStateChanged(callback: (user: AuthUser | null) => void): () => void {
    return onAuthStateChanged(auth, (user: User | null) => {
      if (user) {
        callback({
          uid: user.uid,
          email: user.email
        });
      } else {
        callback(null);
      }
    });
  }

  // 獲取當前用戶
  getCurrentUser(): AuthUser | null {
    const user = auth.currentUser;
    if (user) {
      return {
        uid: user.uid,
        email: user.email
      };
    }
    return null;
  }
}

export const authService = new AuthService();